import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { NgxsModule } from '@ngxs/store';
import { TagState } from '../core/store/tag.state';
import * as fromComponents from './index';
import * as fromServices from '../core/services/index';

import * as fromClientComponents from './index';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [...fromComponents.tagsComponents, ...fromClientComponents.tagsComponents],
  imports: [
    SharedModule,
    NgxsModule.forFeature([TagState]),

    RouterModule.forChild([{ path: '', component: fromComponents.SubscribeTagsComponent }])
  ],
  providers: [fromServices.TagPreloadGuard],
  exports: [...fromComponents.tagsComponents],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class TagsClientModule {
  constructor() {
    console.log('TagsClientModule loaded');
  }
}
